import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createApiCall } from 'services'
import { INTERNAL_USERS_QUERY_KEY } from './useInternalUsers'

type UpdateInternalUserPayload = {
  userId: string
  role_name?: string
  company_ids?: string[]
  active?: boolean
}

type UpdateInternalUserResponse = {
  success: boolean
}

export const useUpdateInternalUser = () => {
  const queryClient = useQueryClient()

  return useMutation<UpdateInternalUserResponse, Error, UpdateInternalUserPayload>({
    mutationFn: async (payload) => {
      const { userId, ...body } = payload
      const response = await createApiCall({
        method: 'PATCH',
        url: `/admins/admin/platform-supervisors/${userId}`,
        data: body,
      })
      return response.data as UpdateInternalUserResponse
    },
    onSuccess: () => {
      // Invalidate internal users query to refetch the list
      queryClient.invalidateQueries({ queryKey: [INTERNAL_USERS_QUERY_KEY] })
    },
  })
}
